import { formatFullDay, type PublicAssetVisit } from "@fusiqo/vozqi-shared";
import type { ReactNode } from "react";
// oxlint-disable-next-line import/no-unassigned-import -- the list's stylesheet, imported for its side effect
import "./asset-visits.css";

/**
 * AN OBJECT'S VISITS, newest first: each delivered visit's day, the object's
 * lines, «Lo que se hizo» and its photos. The public history page and the
 * customer's own page of the object draw the same list; each says how one
 * photo is drawn (`photo`), since one reaches it through the Worker and the
 * other through a signed URL. `photos` is that visit's, for a viewer that
 * walks them.
 */
export function AssetVisits({
  visits,
  photo,
}: {
  visits: PublicAssetVisit[];
  photo: (id: string, at: number, photos: string[]) => ReactNode;
}) {
  return (
    <ol className="asset-visits">
      {visits.map((visit, index) => (
        <li key={`${visit.on}-${String(index)}`} className="asset-visit">
          <p className="asset-visit-day">{formatFullDay(visit.on)}</p>
          {visit.lines.length > 0 && <p className="asset-visit-lines">{visit.lines.join(" · ")}</p>}
          {visit.note.trim() !== "" && <p className="asset-visit-note">«{visit.note.trim()}»</p>}
          {visit.photos.length > 0 && (
            <div className="asset-visit-photos">
              {visit.photos.map((id, at) => (
                <span key={id} className="asset-visit-photo">
                  {photo(id, at, visit.photos)}
                </span>
              ))}
            </div>
          )}
        </li>
      ))}
    </ol>
  );
}
